import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'infinity'
})
export class InfinityPipe implements PipeTransform {
  transform(n: number): any {
    if (n == null) {
      return '∞';
    } else if (n < 1) {
      return 0;
    } else {
      return n;
    }
  }
}
